<template>
  <div class="card bg-light mb-3">
    <div class="card-header">
      <h5 class="card-title">
        <i class="fa fa-file-import"></i>
        {{ $t('CHANNEL_SETTINGS_DEFAULT_IMPORT_VISIBILITY_TITLE') }}:
      </h5>
    </div>

    <div class="card-body">
      <div class="custom-control custom-radio">
        <input type="radio" id="radio_public" name="defaultImportVisibility"
               class="custom-control-input"
               value="public"
               v-model="settings.defaultImportVisibility">
        <label class="custom-control-label" for="radio_public">{{ $t('CHANNEL_SETTINGS_DEFAULT_IMPORT_VISIBILITY_PUBLIC') }}</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="radio_private" name="defaultImportVisibility"
               class="custom-control-input"
               value="private"
               v-model="settings.defaultImportVisibility">
        <label class="custom-control-label" for="radio_private">{{ $t('CHANNEL_SETTINGS_DEFAULT_IMPORT_VISIBILITY_PRIVATE') }}</label>
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="radio_hidden" name="defaultImportVisibility"
               class="custom-control-input"
               value="hidden"
               v-model="settings.defaultImportVisibility">
        <label class="custom-control-label" for="radio_hidden">{{ $t('CHANNEL_SETTINGS_DEFAULT_IMPORT_VISIBILITY_HIDDEN') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultImportVisibility',
  computed: {
    settings() {
      return this.$store.getters.getChannelSettings;
    },
  },
};
</script>

<style scoped>

</style>
